<template>
  <div class="elevated-card chat-widget rating-card">
    <v-row no-gutters class="rating-card-title"> {{ $vuetify.locale.t('$vuetify.__Rating.your_rating') }}</v-row>
    <v-row no-gutters v-if="rating.type === 'thumbs'">
      <div v-if="submitted" style="padding-bottom: 1rem">
        <v-icon v-if="clicked === 'good'" style="font-size: 1.125rem">mdi-thumb-up-outline</v-icon>
        <v-icon v-else-if="clicked === 'bad'" style="font-size: 1.125rem">mdi-thumb-down-outline</v-icon>
      </div>
      <div v-else>
        <v-tooltip location="top" content-class="tooltip-top tooltip-color" aria-label="rating-good-tooltip">
          <template v-slot:activator="{ props }">
            <v-chip class="rating-btn justify-center" :class="clicked === 'good' ? 'clicked-btn' : ''" style="margin-right: 0.625rem" @click="clicked = 'good'" v-bind="props">
              <v-icon style="font-size: 1.125rem">mdi-thumb-up-outline</v-icon>
            </v-chip>
          </template>
          <span>{{ $vuetify.locale.t('$vuetify.__Rating.like') }}</span>
        </v-tooltip>
        <v-tooltip location="top" content-class="tooltip-top tooltip-color" aria-label="rating-bad-tooltip">
          <template v-slot:activator="{ props }">
            <v-chip class="rating-btn justify-center" :class="clicked === 'bad' ? 'clicked-btn' : ''" @click="clicked = 'bad'" v-bind="props">
              <v-icon style="font-size: 1.125rem">mdi-thumb-down-outline</v-icon>
            </v-chip>
          </template>
          <span>{{ $vuetify.locale.t('$vuetify.__Rating.dislike') }}</span>
        </v-tooltip>
      </div>
    </v-row>
    <v-row no-gutters v-if="rating.type === 'scale'">
      <v-col col="12" v-if="submitted" class="gray-card-text" style="padding-bottom: 1rem">{{ clicked }} </v-col>
      <v-col cols="auto" v-else>
        <v-row no-gutters class="gray-card-text" style="padding-bottom: 1rem"> {{ $vuetify.locale.t('$vuetify.__Rating.scale_rating_hint') }} </v-row>
        <v-chip class="scale-btn" v-for="index in 5" :key="index" @click="clicked = index" :class="clicked === index ? 'clicked-btn' : ''">{{ index }}</v-chip>
      </v-col>
    </v-row>
    <v-slide-x-transition>
      <v-row no-gutters v-if="clicked" style="padding-right: 1.5rem">
        <v-col cols="12">
          <v-row no-gutters v-if="submitted" class="gray-card-text"> {{ reason_text }} </v-row>
          <v-row no-gutters v-else>
            <v-textarea
              v-model="reason_text"
              class="textarea-text"
              variant="outlined"
              no-resize
              hide-details
              :placeholder="$vuetify.locale.t('$vuetify.__Rating.field_placeholder')"
              height="4.4375rem"
              style="margin: 1rem 0"
            ></v-textarea>
            <v-btn variant="outlined" class="submit-btn" @click="submitted = true">
              <v-icon color="#e22925">mdi-check</v-icon>
              <span class="submit-btn-text" style="color: #e22925"> {{ $vuetify.locale.t('$vuetify.__General.submit') }}</span>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-slide-x-transition>
  </div>
</template>

<script setup>
// import global_config from '@/../config.json'
import { ref, defineProps } from 'vue'

// Props
const { rating } = defineProps({ rating: Object })

// Data
// const config = ref(global_config)
const clicked = ref('')
const reason_text = ref('')
const submitted = ref(false)
</script>

<style scope>
.rating-card {
  width: 18.1875rem;
  padding: 1rem 0 1rem 1.5rem;
}

.rating-card-title {
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 1.625rem;
  color: #1a1a1a;
  padding-bottom: 1rem;
}

.rating-btn {
  background: transparent;
  border: 0.0625rem solid rgba(0, 0, 0, 0.2);
  border-radius: 0.75rem !important;
  height: 1.875rem !important;
  width: 3.125rem !important;
  padding: 0 1rem;
}

.gray-card-text {
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.375rem;
  color: #828282;
}

.scale-btn {
  background: transparent;
  border: 0.0625rem solid rgba(0, 0, 0, 0.2);
  border-radius: 0.75rem !important;
  width: 2.5625rem;
  height: 2rem;
  margin-right: 0.5rem;
  padding: 0 1rem;
}

.v-chip:not(.v-chip--active .clicked-btn) {
  background: transparent;
}

.v-chip:hover::before {
  opacity: 0.08 !important;
}

.clicked-btn {
  background-color: rgba(0, 0, 0, 0.24) !important;
}

.textarea-text {
  font-family: 'Open Sans' !important;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #828282;
}

.v-application--is-ltr .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
  padding-right: 0.25rem;
}

.v-textarea.v-text-field--enclosed.v-text-field--outlined:not(.v-input--dense) textarea {
  margin-top: 0.25rem;
}

.v-chip.rating-btn .v-icon {
  margin-right: 0;
}
</style>
